import { SKILL_NAMES } from 'js/src/agent/skills/skillNames';
import type { Skill } from '../types';

import { SuggestAnimatedExplainerTool } from 'js/src/agent/tools/sketch/SuggestAnimatedExplainerTool';

export const createAnimatedVideoSkill: Skill = {
    name: SKILL_NAMES.createAnimatedVideo,
    description:
        'Animated, illustrated, cartoon, 2D, or 3D video. Load BEFORE responding to any such request.',
    kind: 'video',
    surfaces: ['sketch'],
    get instructions(): string {
        return `# Animated / Illustrated Video Requests

The user asked for something "animated". Before doing anything else, decide what is
actually being animated — that decides everything.

## The test: is the SUBJECT MATTER itself animated?
Ask: what would be drawn or rendered? Only when the imagery itself is
drawn/rendered animation — characters, illustrated scenes, cartoon worlds, 2D/3D
animation — is this an animated-explainer request. Examples that qualify:
- "give the animation video on its working and application"
- "create it in animation type to train other people"
- "a 3D animated bath-time sequence in a bright colorful world"
- "make a cartoon explainer about how photosynthesis works"

**The word "animation"/"animated" is NOT a trigger on its own.** If what's being
animated is text, typography, captions, icons, logos, overlays, transitions, or a
general "modern/dynamic" style, this is a REGULAR video — those motion effects are
standard in every Lumen5 video:
- "modern typography animations" → regular video
- "elegant animated icons and typography" → regular video
- "modern animations, smooth transitions, and professional text overlays" → regular video

## If the subject matter is animated: route to the Animated Explainer
Call \`${SuggestAnimatedExplainerTool.toolName}\` — it shows the user a CTA banner for our
animated explainer (GenX) feature, which is purpose-built for content that's hard
to show with stock footage. Calling it does not create a video. Afterwards,
briefly note the animated explainer is a better fit and offer to make a regular
video instead if they prefer.

## If it's really a regular video
Say nothing about the animated explainer — load the \`${SKILL_NAMES.createVideo}\` skill and
build normally.`;
    },
};
